import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_SPECIALIST = 'UPDATE_SPECIALIST';
export const UPDATE_SPECIALIST_SUCCESS = 'UPDATE_SPECIALIST_SUCCESS';
export const UPDATE_SPECIALIST_FAILURE = 'UPDATE_SPECIALIST_FAILURE';

// Action Creators
export const updateSpecialist = () => ({
  type: UPDATE_SPECIALIST,
});

export const updateSpecialistSuccess = (data) => ({
  type: UPDATE_SPECIALIST_SUCCESS,
  payload: data,
});

export const updateSpecialistFailure = (error) => ({
  type: UPDATE_SPECIALIST_FAILURE,
  payload: error,
});

// Thunk Function
export const updateSpecialistCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(updateSpecialist(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateSpecialist + data?.id + '/update/',
        data?.body
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(updateSpecialistSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(updateSpecialistFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(updateSpecialistFailure(error.message));
    }
  };
};
